import React from 'react';
import PropTypes from 'prop-types';

import { formatPhoneNumber } from 'common/formatters';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrCard from 'client/components/SrCard/SrCard';
import SrLink from 'client/components/SrLink/SrLink';

const UPAccountManagerCard = ({
  name,
  position,
  email,
  phone,
  profilePictureUrl,
  linkText,
  linkUrl,
}) => {
  return (
    <SrCard margin="0" maxWidth="375px" padding="24px">
      <SrBox display="flex" flexDirection="column" rowGap="12px">
        <SrText font="greycliff" fontSize="24px" weight="800" display="block">
          Your Account Manager
        </SrText>
        <SrBox display="flex" flexDirection="row">
          <SrBox
            borderRadius="50%"
            width="100px"
            height="100px"
            backgroundImage={profilePictureUrl ? `url(${profilePictureUrl})` : undefined}
            backgroundColor={profilePictureUrl ? undefined : 'grey100'}
            backgroundSize="cover"
            backgroundPosition="center"
            marginRight="16px"
            flexShrink="0"
          />
          <SrBox display="flex" flexDirection="column" flex="1" minWidth="0">
            {name && (
              <SrText font="greycliff" fontSize="16px" weight="800" lineHeight="20px">
                {name}
              </SrText>
            )}
            {position && (
              <SrText
                font="greycliff"
                fontSize="12px"
                weight="600"
                lineHeight="16px"
                marginTop={name ? '2px' : null}
              >
                {position}
              </SrText>
            )}
            {email && (
              <SrText
                font="greycliff"
                fontSize="16px"
                lineHeight="20px"
                weight="600"
                marginTop="6px"
                style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}
              >
                {email}
              </SrText>
            )}
            {phone && (
              <SrText font="greycliff" fontSize="16px" lineHeight="20px" weight="600" marginTop="2px">
                {formatPhoneNumber(phone)}
              </SrText>
            )}
            {linkText && linkUrl && (
              <SrLink to={linkUrl} target="_blank" style={{ marginTop: '6px' }}>
                <SrText
                  font="greycliff"
                  fontSize="16px"
                  lineHeight="20px"
                  color="blue300"
                  weight="600"
                  whiteSpace="nowrap"
                >
                  {linkText}
                </SrText>
              </SrLink>
            )}
          </SrBox>
        </SrBox>
      </SrBox>
    </SrCard>
  );
};

UPAccountManagerCard.propTypes = {
  name: PropTypes.string,
  position: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  profilePictureUrl: PropTypes.string,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
};

export default UPAccountManagerCard;
